<template>
    <div v-if="Object.keys(classroomData).length > 0">
        <headful :title="'Caseen Classroom -- ' + classroomData.name" />
        <div id="case-header">
            <div v-if="displayEditor">
                <md-field id="case-title-input">
                    <md-input v-model="classroomData.name" @change="saveClassroom()" maxlength="60" placeholder="Classroom Name" />
                </md-field>
                <md-field id="case-desc-input">
                    <md-textarea v-model="classroomData.description" @change="saveClassroom()" placeholder="Classroom Description"
                        md-autogrow maxlength="300"></md-textarea>
                </md-field>
                You can preview your classroom <a target="_blank" href="?viewer=true">here</a>.
                <br><br>
                <md-field style="width: 400px; margin: auto; transform: scale(0.8);">
                    <label>Classroom Invite URL (click to copy and send to learners)</label>
                    <md-input v-model="classroomURL" readonly
                    @click="copyToClipboard(classroomURL); notify('Copied invitation URL to clipboard')">
                    </md-input>
                </md-field>
            </div>
            <div v-else>
                <h2>{{classroomData.name}}</h2>
                <p>
                    <i>{{classroomData.description}}</i>
                </p>
            </div>
        </div>
        <hr>
        <div v-if="displayEditor">
            <md-tabs>
                <md-tab md-label="Assignments">
                    <md-button class="md-raised md-primary" @click="createAssignment">
                        Create Assignment
                    </md-button>
                    <hr class="soft">
                    <draggable v-model="classroomData.assignments" @end="augmentClassroomData(); saveClassroom()">
                        <div v-for="(assignmentEntry, assignmentIndex) in classroomData.assignments" :key="assignmentIndex"
                        style="cursor: grab;">
                            <a style="font-size: 150%; margin-bottom: 18px; color: black; cursor: pointer;"
                            @click="openAssignmentEditor(assignmentEntry)">
                                {{assignmentEntry.name}}
                            </a>
                            <br>
                            <b style="font-size: 90%; font-style: italic;">
                                Assignment #{{assignmentEntry.index+1}}
                            </b>
                            <br><br>
                            <span style="border: 1px dotted black; padding: 10px;">
                                <b>Mandatory:</b> {{assignmentEntry.mandatory ? "Yes" : "No"}}
                            </span>
                            &nbsp;
                            <span style="border: 1px dotted black; padding: 10px;">
                                <b># of Cases:</b> {{assignmentEntry.numCases}}
                            </span>
                            <hr class="soft">
                        </div>
                    </draggable>
                </md-tab>
                <md-tab md-label="Learners">
                    <br>
                    <i>Click learner names below to view which assignments they have completed.</i>
                    <br><br><br>
                    <md-table v-model="classroomProfiles" md-sort="name" md-sort-order="asc" md-card md-fixed-header>
                        <md-table-toolbar>
                            <h2 class="md-title">Learner List</h2>
                        </md-table-toolbar>
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell md-label="Full Name" md-sort-by="fullName">
                                <a :href="'/classroom/' + classroomID + '/learner/' + item.pid" target="_blank">
                                    <b>{{ item.fullName }}</b>
                                </a>
                            </md-table-cell>
                            <md-table-cell md-label="Send Email" md-sort-by="email">
                                <a :href="'mailto:' + item.email">
                                    To: {{ item.email }}
                                </a>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-tab>
                <md-tab md-label="Admin List" v-if="classroomData.creatorID == $store.state.jwtClaims.id">
                    <ClassroomEditorForm :classroomID="classroomData.id" @notify="notify"/>
                </md-tab>
            </md-tabs>
            <ExcelWriter :classroomData="classroomData" :classroomProfiles="classroomProfiles"/>
        </div>
        <div v-else>
            <br>
            <div v-if="classroomData.isMember">
                <md-table v-if="classroomData.assignments" v-model="classroomData.assignments" 
                md-sort="name" md-sort-order="asc" md-card md-fixed-header>
                    <md-table-toolbar>
                        <h2 class="md-title">Assignment List</h2>
                    </md-table-toolbar>
                    <md-table-row slot="md-table-row" slot-scope="{ item }" 
                    :style="{'background-color': assignmentBgColor(item)}"
                    @click="openAssignmentEditor(item)" style="cursor: pointer;">
                        <md-table-cell md-label="#" md-sort-by="index">
                            {{item.index+1}}
                        </md-table-cell>
                        <md-table-cell md-label="Assignment Name" md-sort-by="name">
                            {{ item.name }}
                        </md-table-cell>
                        <md-table-cell md-label="Completed" md-sort-by="completed">
                            {{item.completed}}
                        </md-table-cell>
                        <md-table-cell md-label="Mandatory" md-sort-by="mandatory">
                            {{item.mandatory ? "Yes" : "No"}}
                        </md-table-cell>
                        <md-table-cell md-label="# of Cases" md-sort-by="numCases">
                            {{item.numCases}}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
                <hr class="soft">
                <md-button @click="leaveClassroom()" class="md-raised md-accent">
                    Leave Classroom
                </md-button>
            </div>
            <div v-else>
                <div style="border: 2px dotted black; max-width: 600px; margin: auto; padding: 20px;">
                    Click the button below to join this classroom. 
                    By joining, you agree to share information on the cases you have completed for class assignments with the owners of this classroom.
                    <br><br>
                    <md-button @click="joinClassroom()" class="md-raised md-primary">
                        Join Classroom
                    </md-button>
                </div>
            </div>
        </div>
        <md-dialog :md-active.sync="showAssignmentViewer" @md-closed="closeAssignmentEditor"
        style="width: 700px; max-width: 100%;">
            <AssignmentViewer :displayEditor="displayEditor" :assignmentData.sync="activeAssignment" 
            :classroomID="classroomData.id" :classroomReviews="classroomReviews" @notify="notify"
            @updateAssignment="updateAssignment" @deleteAssignment="deleteAssignment"/>
        </md-dialog>
        <!-- Notification Snackbar -->
		<md-snackbar md-position="left" :md-duration="1500" :md-active.sync="showNotification">
				<span>{{notificationContents}}</span>
				<md-button class="md-primary" @click="showNotification=false">X</md-button>
		</md-snackbar>
    </div>
</template>

<script>
    import APIRequests from "../APIRequests.js"
    import ClassroomEditorForm from "./ClassroomEditorForm.vue"
    import AssignmentViewer from "./AssignmentViewer.vue"
    import ExcelWriter from "./ExcelWriter.vue"
    import ObjectID  from "bson-objectid"
    import draggable from 'vuedraggable'

    export default {
        components: {
            draggable,
            ClassroomEditorForm,
            AssignmentViewer,
            ExcelWriter,
        },
        props: {
            classroomID: {
                type: String
            }
        },
        data: function(){
            return {
                editorMode: false,
                classroomData: {},
                classroomReviews: [],
                classroomProfiles: [],
                showNotification: false,
                notificationContents: "",
                showAssignmentViewer: false,
                activeAssignment: {},
            }
        },
        computed: {
            displayEditor: function(){
                return this.editorMode && !this.$route.query.viewer
            },
            classroomURL: function(){
                return window.location.protocol + '//' + window.location.host + '/classroom/' + this.classroomID
            }
        },
        methods: {
            assignmentBgColor: function(assignmentInfo){
                return (assignmentInfo.completed == 'Yes') ? '#c3f5ce' : (assignmentInfo.mandatory ? '#ffc0c0' : 'rgb(245, 245, 245)')
            },
            openAssignmentEditor: function(assignmentEntry){
                this.activeAssignment=assignmentEntry
                this.showAssignmentViewer=true
                this.$router.push({query: { 
                    viewer: this.$route.query.viewer,
                    assignment: assignmentEntry.id 
                }})
            },
            closeAssignmentEditor: function(){
                this.showAssignmentViewer=false
                this.activeAssignment={}
                this.$router.push({query: { 
                    viewer: this.$route.query.viewer,
                    assignment: undefined 
                }})
            },
            copyToClipboard: function(clipboardPayload){
                const el = document.createElement('textarea');
                el.value = clipboardPayload;
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
            },
            notify: function(notificationString){
				this.notificationContents = notificationString;
				this.showNotification = true;
            },
            getClassroomData: function(){
                var api_url = this.$store.state.api_url + "/api/classrooms/" + this.classroomID
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    if(!data.classroomData) data.classroomData = {assignments: []}
                    this.classroomData = data.classroomData
                    this.augmentClassroomData()
                    this.editorMode = data.editorMode
                    if(this.editorMode){ 
                        if(!data.classroomProfiles) data.classroomProfiles = []
                        this.classroomProfiles = data.classroomProfiles
                    }
                })
            },
            getMyClassroomReviews: function(){
                var api_url = this.$store.state.api_url + "/api/classrooms/" + this.classroomID + "/myReviews" 
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    if(!data) data=[]
                    this.classroomReviews=data
                })
            },
            augmentClassroomData: function(){
                let newAssignments = this.classroomData.assignments.map((assignment, i) => {
                    assignment["index"] = i
                    assignment["numCases"] = assignment.caseList.length
                    assignment["completed"] = assignment.caseList.every((caseEntry) => {
                        if(this.classroomReviews.length < 1) return false
                        return this.classroomReviews.filter(review => review.cid == caseEntry && review.reporting.assignmentID == assignment.id).length > 0
                    })  ? "Yes" : "No"
                    return assignment
                })
                this.$set(this.classroomData, "assignments", newAssignments)
            },
            updateAssignment: function(updatedAssignment){
                let newAssignments = this.classroomData.assignments
                newAssignments[updatedAssignment.index] = updatedAssignment
                this.$set(this.classroomData, "assignments", newAssignments)
                this.saveClassroom()
                this.augmentClassroomData()
            },
            deleteAssignment: function(){
                let updatedAssignmentList = this.classroomData.assignments
                updatedAssignmentList.splice(this.activeAssignment.index, 1)
                this.$set(this.classroomData, "assignments", updatedAssignmentList)
                this.saveClassroom()
                this.augmentClassroomData()
                this.showAssignmentViewer = false;
                this.activeAssignment = {}
            },
            saveClassroom: function(){
                if(!this.editorMode) return
                if(this.classroomData.name.trim().length < 1) this.classroomData.name = "Unnamed Classroom"
                var api_url = this.$store.state.api_url + "/api/classrooms/update"
                return APIRequests.postJSONData(
                    api_url,
                    this.classroomData,
                    this.$store.state.jwtToken
                ).then(() => {
                    this.notify("Saved classroom!")
                })                
            },
            createAssignment: function(){
                if(!confirm("Are you sure you want to create a new assignment?")) return
                let newAssignment = {
                    id: ObjectID().toHexString(),
                    name: "Unnamed Assignment",
                    description: "",
                    mandatory: false,
                    caseList: [],
                }
                this.classroomData.assignments.push(newAssignment)
                this.saveClassroom()
                this.augmentClassroomData()
                this.activeAssignment = this.classroomData.assignments[this.classroomData.assignments.length-1]
                this.showAssignmentViewer = true
            },
            joinClassroom: function(){
                var api_url = this.$store.state.api_url + "/api/classrooms/" + this.classroomID + "/join"
                return APIRequests.getJSONData(
                    api_url,
                    this.$store.state.jwtToken
                ).then(() => {
                    window.location.reload()
                })     
            },
            leaveClassroom: function(){
                if(!confirm("Are you sure you want to leave this classroom?")) return
                var api_url = this.$store.state.api_url + "/api/classrooms/" + this.classroomID + "/leave"
                return APIRequests.getJSONData(
                    api_url,
                    this.$store.state.jwtToken
                ).then(() => {
                    window.location.reload()
                })     
            },
        },
        mounted: function(){
            this.$nextTick(function () {
                this.getMyClassroomReviews()
                .then(() => this.getClassroomData())
                .then(() => {
                    if(this.$route.query.assignment){
                        let assignmentID = this.$route.query.assignment
                        let matchingAssignments = this.classroomData.assignments.filter((assignmentEntry) => {
                            return assignmentEntry.id == assignmentID
                        })
                        if(matchingAssignments.length == 1){
                            this.activeAssignment = matchingAssignments[0]
                            this.showAssignmentViewer = true
                        }
                    }
                }).catch(()=>{
                    this.$router.replace("/classrooms")
                })
            })
        }
    }
</script>